import { sliderData } from "../../componentsUpdated/Dashboard/Db/MainDashboard/constant";
import BookingForm from "../BookingForm";
import Facilitate from "../Facilitate";
import HealthCare from "../HealthCare";
import HowItWorks from "../HowItWorks";
import CustomCarousel from "../ImageCarousel";
import { WebsiteLayout } from "../Layouts/WebsiteLayout";
import RegisterAsProvider from "../RegisterAsProvider";
import WhyChooseUs from "../WhyChooseUs";

const LandingPage = () => {
  return (
    <WebsiteLayout className={"bg-lightGray"}>
      <div className="relative overflow-hidden">
        <CustomCarousel swiperContent={sliderData} />
        <div className="absolute top-15 sm:top-28 w-full flex justify-center items-center  lg:pt-16">
          <div className="md:px-20 xl:px-36 2xl:px-72  xl:block">
            <BookingForm showTitle={false} blackSeparation={false} />
          </div>
        </div>
      </div>
      <div className="bg-white">
        <Facilitate />
        <WhyChooseUs />
        <HealthCare />
        <HowItWorks />
        <RegisterAsProvider />
      </div>
    </WebsiteLayout>
  );
};

export default LandingPage;
